import { Injectable } from '@angular/core';
import { QueryFunctions, QueryFunctionType, QueryParams, QueryParamType } from './query-params-types';

@Injectable({ providedIn: 'root' })
export class QueryParamsService {
  private readonly _functionQueryKey = 'function';
  private _queryParams = this.getAllParameters();

  private getAllParameters(): { [paramName: string]: string } {
    const params: { [paramName: string]: string } = {};
    const url = this.getCurrentUrl();
    const index = url.indexOf('?');
    if (index === -1) {
      return params;
    }
    const query = url.substring(index + 1);
    const queryParams = query.split('&');
    for (const param of queryParams) {
      const pair = param.split('=');
      const key = pair[0];
      const value = decodeURIComponent(pair[1])

      const isFunction = (key === this._functionQueryKey) && QueryFunctions.includes(value as QueryFunctionType);
      if (isFunction || QueryParams.includes(key as QueryParamType)) {
        params[key] = isFunction ? value.toLocaleLowerCase() : value;
      }
    }
    return params;
  }

  private getCurrentUrl(): string {
    return window.location.href;
  }

  public hasFunction(functionName: QueryFunctionType): boolean {
    return this._queryParams[this._functionQueryKey] === functionName.toLocaleLowerCase();
  }

  public getParamValue(param: QueryParamType): string {
    return this._queryParams[param];
  }

  public createFunctionUrlParameter(functionName: QueryFunctionType): string {
    return `${this._functionQueryKey}=${functionName}`;
  }
}
